import React from 'react'

import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST,
  LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE
} from 'api/actions'

const styles = theme => ({
  root: { paddingLeft: 10, paddingTop: 10 },
  shortestIcon: {
    color: 'rgba(255, 0, 0, 0.30)',
    marginLeft: 10
  },
  distanceIcon: {
    color: '#4f57d5'
  },
  distanceIconShade: {
    color: '#4f57d5'
  },
  distances: {
    display: 'inline-flex'
  }
})

class SearchPanelDirectionsDistance extends React.Component {
  constructor (props) {
    super(props)
    const { classes } = this.props
    this.pure = {}
    this.pure.distanceIconShade = <FiberManualRecordIcon className={classes.distanceIconShade}/>
    this.pure.distanceIcon = <FiberManualRecordIcon className={classes.distanceIcon}/>
    this.pure.distanceShortestIcon = <FiberManualRecordIcon className={classes.shortestIcon}/>
  }

  render () {
    const { classes, travelMode, distanceKM, distanceKMShortest, expanded } = this.props

    if (!expanded || distanceKM <= 0) {
      return null
    }

    let distanceMarkup = null
    let prependTextShortest = ''
    let distanceIcon = null
    if (travelMode === 'shade') {
      distanceIcon = this.pure.distanceIconShade
      prependTextShortest = ' (shortest)'
    } else {
      distanceIcon = this.pure.distanceIcon
    }

    if (distanceKM >= 1) {
      distanceMarkup = <div>{distanceIcon}{'' + Math.round(distanceKM * 100) / 100 + ' km'}</div>
    } else {
      distanceMarkup = <div>{distanceIcon}{'' + (Math.round(distanceKM * 100) / 100) * 1000 + ' m'}</div>
    }

    let distanceMarkupShortest = null
    if (distanceKMShortest > 0) {
      if (distanceKMShortest >= 1) {
        distanceMarkupShortest = <span>{this.pure.distanceShortestIcon}{'' + Math.round(distanceKMShortest * 100) / 100 + ' km' + prependTextShortest}</span>
      } else {
        distanceMarkupShortest = <span>{this.pure.distanceShortestIcon}{'' + (Math.round(distanceKMShortest * 100) / 100) * 1000 + ' m' + prependTextShortest}</span>
      }
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <div className={classes.distances}>
              {distanceMarkup}{distanceMarkupShortest}
            </div>
          </Grid>
        </Grid>
      </div>
    )
  }
}

SearchPanelDirectionsDistance.propTypes = {
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  distanceKM: PropTypes.number.isRequired,
  distanceKMShortest: PropTypes.number.isRequired,
  travelMode: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, true)
  const distanceKM = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM, 0)
  const distanceKMShortest = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_DISTANCE_KM_SHORTEST, 0)
  const travelMode = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_TRAVEL_MODE, 'car')
  return {
    expanded,
    distanceKM,
    distanceKMShortest,
    travelMode
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelDirectionsDistance)
  )
)
